import React from 'react';

import NumberFormat from 'react-number-format';

//Estilos base:
let paragraphBaseStyle = { fontSize: "1.15em", textTransform: "none" };

let FileDetailBlock = (props) => {
    return (
        <React.Fragment>
            <p className="muted-text" style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}>
                <b>Nombre: </b>
                {getFileName(props.fileDetail)}
            </p>

            <p className="muted-text" style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}>
                <b>Total de registros: </b>
                {getRecordsNumber(props.fileDetail)}
            </p>

            <p className="muted-text" style={{ ...paragraphBaseStyle, paddingLeft: 30, fontSize: "0.9em" }}>
                <b>Tamaño: </b>
                {getFileSize(props.fileDetail)}
            </p>
        </React.Fragment>
    );
}

let getFileName = (fileDetail) => {
    try {
        let storage_path = fileDetail.storage_path;
        return storage_path.split("/")[(storage_path.split("/").length - 1)];
    }
    catch (error) { console.log(error); console.log(this.state.fileDetail); return "" }
}

let getFileSize = (fileDetail) => {
    try {
        let fileSize = fileDetail.size;
        return (
            <React.Fragment>
                <NumberFormat thousandSeparator={true} displayType="text" value={fileSize} />
                {" bytes"}
            </React.Fragment>
        );
    }
    catch (error) { console.log(error); console.log(this.state.fileDetail); return "" }
}

let getRecordsNumber = (fileDetail) => {
    console.log(fileDetail);
    try {
        let recordsNumber = fileDetail.records_number;
        return (
            <React.Fragment>
                <NumberFormat thousandSeparator={true} displayType="text" value={recordsNumber} />
                {" registros"}
            </React.Fragment>
        );
    }
    catch (error) { console.log(error); console.log(this.state.fileDetail); return "" }
}

export default FileDetailBlock;